// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1mvXa","ranges":"BmiRanges_ranges__26b2D"};